import { render, staticRenderFns } from "./ExitDeclarationDownload.vue?vue&type=template&id=8c8f7dce&"
import script from "./ExitDeclarationDownload.vue?vue&type=script&lang=js&"
export * from "./ExitDeclarationDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports